import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=3a6f9831&scoped=true&"
import script from "./Scene.vue?vue&type=script&lang=js&"
export * from "./Scene.vue?vue&type=script&lang=js&"
import style0 from "./Scene.vue?vue&type=style&index=0&id=3a6f9831&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f9831",
  null
  
)

export default component.exports